<template>
    <div class="w-full max-w-500 mx-auto min-h-screen" data-cy="container_history_favourite_main">
        <div class="w-full h-full bg-a-blue-f2f5ff fixed top-0 left-0 right-0"></div>
        <HistoryMenu data-cy="component_history_menu" />
        <div class="mt-5 px-4 pb-28 relative" data-cy="container_history_favourite_content">
            <CampaignFavouriteList
                ref="campaign-favourite-list"
                data-cy="list_history_favourite"
            ></CampaignFavouriteList>
        </div>
        <MenuBar />
    </div>
</template>
<script>
//component
import HistoryMenu from '../component/HistoryMenu/HistoryMenu.vue';
import MenuBar from '@/components/Layout/MenuBar/MenuBar.vue';
import CampaignFavouriteList from "@/module/List/component/CampaignList/CampaignFavouriteList.vue";
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';

export default {
    name: 'Favourite',
    mixins: [AuthPageMixin],
    components: {
        HistoryMenu,
        MenuBar,
        CampaignFavouriteList,
    },
    created: function(){
        this.tracking.screenName('history');
        this.tracking.event('history_favorite', 'history_favorite', null, null);
    }
}
</script>
